// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

// NPC player types for automated gameplay

import type { AnswerCard, TreatmentCard } from './game';

export type StrategyType = 'random' | 'sequential';

export interface NpcStrategy {
  name: StrategyType;
  selectAnswerCard(options: AnswerCard[]): AnswerCard;
  selectTreatmentCards(hand: TreatmentCard[], count: number): number[];
  pickWinningSubmission(submissions: Record<string, TreatmentCard[]>): string;
}

export interface NpcConfig {
  enabled: boolean;
  strategy: StrategyType;
  delayMs: number;
}

export interface NpcActionLog {
  timestamp: Date;
  action: string;
  details: string;
}

export const DEFAULT_NPC_CONFIG: NpcConfig = {
  enabled: false,
  strategy: 'random',
  delayMs: 1000,
};
